import { ListResult } from '../fetchers/ListResult';
import { ColumnWidths } from '../models/ColumnWidths';
import { ISliceable } from '../models/ISliceable';
import { ITemplate } from '../models/ITemplate';
import { SliceableFactory } from '../services/SliceableFactory';

export interface IDataGridScope extends ng.IScope {
  // Bound to attributes
  headers: ITemplate[];
  cells: ITemplate[];
  items: ISliceable<any>;
  currentRowIndex: number;
  isRowSelected: (locals: { row: any; }) => boolean;
  headerClicked: (locals: { header: ITemplate; }) => any;
  rowClicked: (locals: { row: any; colIndex?: number; }) => any;
  sliceChanged: (locals: { newSlice: ListResult<any>; }) => any;

  // Added in controller
  columnWidths: ColumnWidths;
  scrollLeftChanged: (scrollLeft: number) => any;
}

export class DataGridCtrl {

  public static $inject = ['$scope', '$element', 'SliceableFactory'];

  constructor($scope: IDataGridScope, $element: JQuery, SliceableFactory: SliceableFactory) {
    if(!$scope.columnWidths) {
      $scope.columnWidths = new ColumnWidths();
    }
    $scope.scrollLeftChanged = (scrollLeft: number) => {
      $element.find('.tb-data-grid-headers').css({'margin-left': -scrollLeft + 'px'});
    };
  }

}
